<template>
    <input
        class="block w-full px-4 py-2 mb-2 transition duration-150 ease-in-out border rounded-md form-field-text form-field-bg sm:text-sm sm:leading-5"
        :class="{
            'form-field-error-border form-state-focus-error': error,
            'form-field-border form-state-focus': !error,
        }"
        :value="modelValue"
        @input="updateValue($event.target.value)"
    />
</template>

<script>
export default {
    props: ['modelValue', 'error'],
    methods: {
        updateValue: function (value) {
            // Emit the number value through the input event
            this.$emit('update:modelValue', value);
        },
    },
};
</script>
